import React, { useEffect, useState } from "react";
import NavbarVolver from "./navbarVolver";
import { cargaAllExcel, cargaAllExcelProveedor } from "../services/excel.jsx";
import { cargaProveedoresExcel } from "../services/proveedores.jsx";
import { ENDPOINT } from "../config/endpoint.jsx";
import Swal from "sweetalert2";

export default function MostrarExcel() {
  const [datos, setDatos] = useState([]);
  const [datosCbo, setDatosCbo] = useState([]);
  const [selectedCbo, setSelectedCbo] = useState("XX");

  useEffect(() => {
    cargaAllExcel()
      .then((data) => setDatos(ordenarDatos(data)))
      .catch((error) => console.error(error));
    cargaProveedoresExcel()
      .then((data) => {
        const sinVacios = data.filter((e) => e.cantidad > 0);
        setDatosCbo(sinVacios);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    if (selectedCbo === "XX") {
      cargaAllExcel()
        .then((data) => setDatos(ordenarDatos(data)))
        .catch((error) => console.error(error));
      return;
    }
    cargaAllExcelProveedor(selectedCbo)
      .then((data) => setDatos(ordenarDatos(data)))
      .catch((error) => console.error(error));
  }, [selectedCbo]);

  const ordenarDatos = (data) => {
    return data.sort((a, b) => {
      const [dA, mA, yA] = a.fecha.split("-");
      const [dB, mB, yB] = b.fecha.split("-");
      const fechaA = new Date(yA, mA - 1, dA, ...a.hora.split(":").map(Number));
      const fechaB = new Date(yB, mB - 1, dB, ...b.hora.split(":").map(Number));
      return fechaB - fechaA;
    });
  };

  const handleClickDelete = (id) => {
    Swal.fire({
      title: "Eliminar Excel?",
      text: "No podras recuperarlo!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#C04040",
      cancelButtonColor: "#6B6B6B",
      confirmButtonText: "Si, Eliminar!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${ENDPOINT}/eliminarExcel/${id}`, {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
          });

          if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
          }

          const data = await response.json();
          Swal.fire({
            title: "Eliminado!",
            text: data.message,
            icon: "success",
          });
          setDatos((prev) => prev.filter((dato) => dato.id !== id));
        } catch (error) {
          console.error("Error:", error);
          Swal.fire({
            title: "Error!",
            text: error.message,
            icon: "error",
          });
        }
      }
    });
  };

  return (
    <>
      <NavbarVolver />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-6">
        <h1 className="page-title">Listado Planillas de Pedidos</h1>

        <div className="card p-4">
          <label className="label-field">Filtrar por Proveedor:</label>
          <select
            className="select-field max-w-sm"
            value={selectedCbo}
            onChange={(e) => setSelectedCbo(e.target.value)}
          >
            <option value="XX">Todos los proveedores</option>
            {datosCbo.map((e) => (
              <option key={e.id} value={e.id}>
                {e.nombre}
              </option>
            ))}
          </select>
        </div>

        <div className="card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="table-header">
                  <th className="px-4 py-3 text-left">Proveedor</th>
                  <th className="px-4 py-3 text-left">Fecha</th>
                  <th className="px-4 py-3 text-left">Hora</th>
                  <th className="px-4 py-3 text-center">Descargar</th>
                  <th className="px-4 py-3 text-center">Eliminar</th>
                </tr>
              </thead>
              <tbody>
                {datos.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="px-4 py-12 text-center text-ink-muted">
                      No hay datos para mostrar
                    </td>
                  </tr>
                ) : (
                  datos.map((e) => (
                    <tr key={e.id} className="table-row">
                      <td className="px-4 py-3">
                        <span className="text-sm font-semibold text-ink">{e.nombre}</span>
                      </td>
                      <td className="px-4 py-3">
                        <span className="text-sm text-ink-muted">{e.fecha}</span>
                      </td>
                      <td className="px-4 py-3">
                        <span className="text-sm text-ink-muted">{e.hora}</span>
                      </td>
                      <td className="px-4 py-3 text-center">
                        <a
                          href={`${ENDPOINT}/descargar/${e.nombreArchivo}`}
                          download
                          className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-success/10 text-success hover:bg-success hover:text-white transition-all duration-200"
                          title="Descargar"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                          </svg>
                        </a>
                      </td>
                      <td className="px-4 py-3 text-center">
                        <button
                          onClick={() => handleClickDelete(e.id)}
                          className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-danger/10 text-danger hover:bg-danger hover:text-white transition-all duration-200"
                          title="Eliminar"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
